import { useMemo } from "react";
import axios from "axios";
import * as Yup from "yup";
import {
  Typography,
  Alert,
  Grid,
  Box,
  Divider,
  List,
  ListItem,
  ListItemText,
  Paper,
  Stack,
  RadioGroup,
  Radio,
  FormControl,
  FormControlLabel,
  Collapse,
  Checkbox,
  Tooltip,
  IconButton,
  CircularProgress
} from "@mui/material";
import PageProtectedOnboarding from "../../../components/Page/PageProtectedOnboarding";
import { useFormik } from "formik";
import { useState, useEffect } from "react";
import { API_URL } from "../../../constants";
import { useAuth } from "../../../provider";
import { useLocation } from "react-router-dom";
import { pool } from "../../../constants";
import OnboardingSteps from "../../../components/Steps/OnboardingSteps";
import ButtonForm from "../../../components/Button/ButtonForm";
import ButtonsMain from "../../../components/Button/ButtonMain";
import { ShoppingCart, ChevronDown, ChevronUp, Info } from "lucide-react";
import DiaBaseTests from "./DiaBaseTests";
import DiaGutTest from "./DiaGutTest";
import {
  motion,
  //AnimatePresence,
  useMotionValue,
  useTransform,
  animate,
} from "framer-motion";
import EmbeddedCheckout from "./EmbeddedCheckout";

import CustomDialogSmall from "../../../components/Dialog/DiaCompSmall"
import VitaminsAddOnCard from "../Subscribe/ShopCardsAddOn/VitaminsAddOnCard";
import OmegaAddOnCard from "../Subscribe/ShopCardsAddOn/OmegaAddOnCard";
import HormFemaleAddOnCard from "../Subscribe/ShopCardsAddOn/HormFemaleAddOnCard";
import HormMaleAddOnCard from "../Subscribe/ShopCardsAddOn/HormMaleAddOnCard";
import ThyroidAddOnCard from "../Subscribe/ShopCardsAddOn/ThyroidAddOnCard";
import EnergyAddOnCard from "../Subscribe/ShopCardsAddOn/EnergyAddOnCard";
import BonesAddOnCard from "../Subscribe/ShopCardsAddOn/BonesAddOnCard";
import FertilityAddOnCard from "../Subscribe/ShopCardsAddOn/FertilityAddOnCard";
import ColonAddOnCard from "../Subscribe/ShopCardsAddOn/ColonAddOnCard";
import { stripePromise } from "../../../constants";

export default function MembershipConfig() {

  const { state } = useAuth();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState("");
  const [selectedMembership, setSelectedMembership] = useState("2");
  const [selectedFrequency, setSelectedFrequency] = useState("2");
  const [selectedPlan, setSelectedPlan] = useState("3");

  const [showAddOns, setShowAddOns] = useState(false);
  const [selectedAddOns, setSelectedAddOns] = useState([]);
  const [checkout, setCheckout] = useState()

  const [infoOpen, setInfoOpen] = useState(false);
  const [infoContent, setInfoContent] = useState(null);



// --------- 27 option -> Stripe price ID map (replace placeholders with real price IDs)
const priceIdMap = {
  "1":  "1", 
  "2":  "2",
  "3":  "3",
  "4":  "4",
  "5":  "5",
  "6":  "6",
  "7":  "7",
  "8":  "8",
  "9":  "9",

  "10": "10",
  "11": "11",
  "12": "12",
  "13": "13",
  "14": "14",
  "15": "15",
  "16": "16",
  "17": "17",
  "18": "18",

  "19": "19",
  "20": "20",
  "21": "21",
  "22": "22",
  "23": "23",
  "24": "24",
  "25": "25",
  "26": "26",
  "27": "27",
};

// --------- helper to compute option id 1..27 from selected controls
// Note mapping convention (matches your list):
// plan groups: 1Y -> 0 offset, 2Y -> +9, 4Y -> +18
// within a plan: core (1..3), microbiome (4..6), both (7..9)
// frequency order: 1T -> index 0, 2T -> 1, 4T -> 2
const computeOptionId = (membership, frequency, plan) => {
  // membership: "1" = Core, "2" = Core+Microbiome (Both), "3" = Microbiome only
  const planOffsets = { "1": 0, "2": 9, "3": 18 };
  // membershipIndex: Core->0, Microbiome->1, Both->2 based on your option ordering
  // careful: your selectedMembership uses 1=Core, 2=Both, 3=Gut
  // so map to the ordering used in the list:
  const membershipIndexMap = { "1": 0, "2": 2, "3": 1 };
  const freqIndexMap = { "1": 0, "2": 1, "3": 2 };

  const planOffset = planOffsets[plan] ?? 0;
  const membershipIndex = membershipIndexMap[membership] ?? 0;
  const freqIndex = freqIndexMap[frequency] ?? 0;

  const optionId = planOffset + membershipIndex * 3 + freqIndex + 1; // +1 because ids start at 1
  return String(optionId);
};

// compute selectedOptionId and priceId using useMemo (recomputed when dependencies change)
const selectedOptionId = useMemo(
  () => computeOptionId(selectedMembership, selectedFrequency, selectedPlan),
  [selectedMembership, selectedFrequency, selectedPlan]
);
const selectedPriceId = priceIdMap[selectedOptionId]; // may be undefined if not set

const addOnPriceIdMap = {
  vitamins: "price_1SI63bAbLpI3osd3GLYeh4V1",
  omega: "price_1SI68zAbLpI3osd3Cz8WeISs",
  horm_female: "price_1SI64mAbLpI3osd3jXffLgwc",
  horm_male: "price_1SI65OAbLpI3osd3Dt86G3kN",
  thyroid: "price_1SI668AbLpI3osd3eUg7bXMX",
  atherosclerosis: "price_1SI67HAbLpI3osd3JVNqxg56",
  bones: "price_1SIs6mAbLpI3osd3C1FWRgap",
  fertility: "price_1SLfUGAbLpI3osd3WhSh5iNy",
  ifob: "price_1SLfZVAbLpI3osd3y61rNSr7",
};

  const addOns = [
    { id: "vitamins", name: "Vitamins & Micronutrients", price: 300, component: <VitaminsAddOnCard /> },
    { id: "omega", name: "OMEGA Health Lifestyle", price: 100, component: <OmegaAddOnCard /> },
    { id: "horm_female", name: "Hormone & Fertiliy Female", price: 200, component: <HormFemaleAddOnCard /> },
    { id: "horm_male", name: "Hormone & Cancer Prevention Male", price: 200, component: <HormMaleAddOnCard /> },
    { id: "thyroid", name: "Thyroid Health", price: 90, component: <ThyroidAddOnCard /> },
    { id: "atherosclerosis", name: "Atherosclerosis Prevention", price: 180, component: <EnergyAddOnCard /> },
    { id: "bones", name: "Bones Health", price: 140, component: <BonesAddOnCard /> },
    { id: "fertility", name: "Fertility & Ovarian Reserve", price: 50, component: <FertilityAddOnCard /> },
    { id: "ifob", name: "Colon Cancer Prevention IFOB Test", price: 20, component: <ColonAddOnCard /> },
  ];

  const toggleAddOn = (id) => {
    setSelectedAddOns((prev) =>
      prev.includes(id) ? prev.filter((a) => a !== id) : [...prev, id]
    );
  };

  const addOnTotal = addOns
    .filter((a) => selectedAddOns.includes(a.id))
    .reduce((sum, a) => sum + a.price, 0);

  const cartDetails = {
    membership: {
      1: { name: "Bloodtest Only", basePrice: 300 },
      2: { name: "Core Bloodtest + Gut Microbiome Test", basePrice: 520 },
      3: { name: "Gut Microbiome Test Only", basePrice: 220 },
    },
    frequency: {
      1: { name: "Annual Testing (1x / year)", testsPerYear: 1, discountPerTest: 0 },
      2: { name: "Bi-Annual Testing (2x / year)", testsPerYear: 2, discountPerTest: 10 },
      3: { name: "Quarterly Testing (4x / year)", testsPerYear: 4, discountPerTest: 20 },
    },
    plan: {
      1: { name: "1-Year Plan", discountPerTest: 0 },
      2: { name: "2-Year Plan (24 Months)", discountPerTest: 20 },
      3: { name: "4-Year Plan (48 Months)", discountPerTest: 40 },
    },
  };

  // 🎯 Selected options
  const membershipItem = cartDetails.membership[selectedMembership];
  const frequencyItem = cartDetails.frequency[selectedFrequency];
  const planItem = cartDetails.plan[selectedPlan];

  // 🧮 Logic
  const basePrice = membershipItem.basePrice;
  const testsPerYear = frequencyItem.testsPerYear;

  const subtotal = basePrice * testsPerYear;
  const frequencyDiscount = frequencyItem.discountPerTest * testsPerYear * -1;
  const planDiscount = planItem.discountPerTest * testsPerYear * -1;
  const total = subtotal + frequencyDiscount + planDiscount + addOnTotal;

  // 🪄 Animated values
  const subtotalMotion = useMotionValue(subtotal);
  const freqDiscMotion = useMotionValue(frequencyDiscount);
  const planDiscMotion = useMotionValue(planDiscount);
  const addOnMotion = useMotionValue(addOnTotal);
  const totalMotion = useMotionValue(total);

  const subtotalDisplay = useTransform(subtotalMotion, (v) => v.toFixed(0));
  const freqDiscDisplay = useTransform(freqDiscMotion, (v) => v.toFixed(0));
  const planDiscDisplay = useTransform(planDiscMotion, (v) => v.toFixed(0));
  const addOnDisplay = useTransform(addOnMotion, (v) => v.toFixed(0));
  const totalDisplay = useTransform(totalMotion, (v) => v.toFixed(0));

  useEffect(() => {
    animate(subtotalMotion, subtotal, { duration: 0.4 });
    animate(freqDiscMotion, frequencyDiscount, { duration: 0.4 });
    animate(planDiscMotion, planDiscount, { duration: 0.4 });
    animate(addOnMotion, addOnTotal, { duration: 0.4 });
    animate(totalMotion, total, { duration: 0.5 });
  }, [subtotal, frequencyDiscount, planDiscount, addOnTotal, total]);


//------ CHECKOUT ------------

const formik = useFormik({
    initialValues: {
      email: state.user?.email || "",
      userId: state.user?.id || "",
      //firstName: state.user?.first_name || "",
      //lastName: state.user?.last_name || "",
      stripe_cust_id: state.user?.stripe_customer_id
    },
    validationSchema: Yup.object({
      email: Yup.string().email().required(),
      userId: Yup.string().required(),
      //firstName: Yup.string().required(),
      //lastName: Yup.string().required(),
      stripe_cust_id: Yup.string().required(),
    }),
    onSubmit: async (values) => {
      setError(null);
      setMessage("Redirecting to Stripe checkout...");
      setLoading(true);
      try {
        // === 1️⃣ Create subscription checkout session ===
        const payload = {
          email: values.email,
          userId: values.userId,
          custid: values.stripe_cust_id,
          planOption: selectedPriceId, // send selected subscription / membership option
          addons: selectedAddOns.map(id => ({
            sku: id,                       // or product_id
            quantity: 1,
          })),
        };
        setCheckout(payload.planOption, payload.addons)
        const Response = await axios.post(`${API_URL}/api/stripe/create-chained-checkout/`, payload);
        const SessionId = Response.data.sessionId;
        const sessionUrl = Response.data.url;
        
        // Stripe best practice: some servers return session.url
        if (sessionUrl) {
          window.location.href = sessionUrl;
          return;
          }
       
        // === 3️⃣ Redirect to Stripe (subscription checkout takes precedence) ===
        const stripe = await stripePromise;
        const result = await stripe.redirectToCheckout({ sessionId: SessionId });

        if (result.error) {
          console.error(result.error.message);
          setError("Stripe checkout failed to start.");
        }

      } catch (error) {
        console.error(error.response?.data || error.message)
        setError("Checkout initialization failed.");
       } finally {
      setLoading(false);
    }
    },
  });

  const handleSuccess = async () => {
        // go to next onboarding step
    }

  return (

    <PageProtectedOnboarding
      headerImage={pool}
      brandtext="Preventive Health Intelligence"

      content={
        <>
          
          {/* Onboarding Steps */}
         <Grid container spacing={2} sx={{mb: 2, p: 2, display: 'flex', justifyContent: 'center'}}>
                 <Grid size={{xs: 12}} sx={{maxWidth: 760}}>
                   <OnboardingSteps stepNumber={0} />
                 </Grid>
               </Grid>

          {/* Explain status */}
            <Grid container spacing={2} sx={{ my: 2, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Grid size={{ xs: 12 }} sx={{ maxWidth: 700, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Typography variant="subtitle1" textAlign="center" gutterBottom sx={{ mb: 2, fontWeight: 400 }}> 
                           Please choose your preferred membership type (we marked recommended options).<br /> 
                           Optionally add one or more test packages for your first lab visit.
                          
                </Typography>
                </Grid>
              </Grid>


          {/* === Unified Cart === */}
          <Grid container justifyContent="center">
            <Grid item xs={12} md={8}>
              <Paper
                elevation={4}
                sx={{
                  minWidth: {xs:460, sm:500, md:760},
                  mb:4,
                  p: 6,
                  borderRadius: 2,
                  bgcolor: "grey.C50",
                }}
              >
                <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                  <ShoppingCart />
                  <Typography variant="h5" sx={{ fontWeight: 600 }}>
                    &nbsp;Membership Configurator
                  </Typography>
                </Stack>
                <Divider sx={{ mb: 3 }} />

                {/* Membership Selection */}
                <Stack spacing={4}>
                  <FormControl>
                    <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600 }}>
                      Annual Membership (auto-renewal every year)
                    </Typography>
                    <RadioGroup
                      //row
                      value={selectedMembership}
                      onChange={(e) => setSelectedMembership(e.target.value)}
                    >
                      <FormControlLabel value="2" control={<Radio sx={{color: "greydark.100","&.Mui-checked": { color: "greydark.C900" },}}/>} label="Core Bloodtest + Gut Microbiome Test (Recommended)" />
                      <FormControlLabel value="1" control={<Radio sx={{color: "greydark.100","&.Mui-checked": { color: "greydark.C900" },}}/>} label="Core Bloodtest Only" />
                      <FormControlLabel value="3" control={<Radio sx={{color: "greydark.100","&.Mui-checked": { color: "greydark.C900" },}}/>} label="Gut Microbiome Test Only" />
                    </RadioGroup>
                  </FormControl>
                </Stack>

                <Stack direction="row" alignItems="center" spacing={1}>
                  <Typography variant="body1">&nbsp;Click here to see the 60+ bloodmarkers included in the Core Bloodtest</Typography>
                  <DiaBaseTests />
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Typography variant="body1">&nbsp;Click here to see the Gut Microbiome Test Details</Typography>
                  <DiaGutTest />
                </Stack>

                <Divider sx={{ my: 3 }} />

                {/* Frequency + Plan Selection */}
                <Stack spacing={4}>
                  <FormControl>
                    <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 400 }}>
                      How often do you want to test per year?
                    </Typography>
                    <RadioGroup
                      row
                      value={selectedFrequency}
                      onChange={(e) => setSelectedFrequency(e.target.value)}
                    >
                      <FormControlLabel value="1" control={<Radio sx={{color: "greydark.100","&.Mui-checked": { color: "greydark.C900" },}}/>} label="Annual" />
                      <FormControlLabel value="2" control={<Radio sx={{color: "greydark.100","&.Mui-checked": { color: "greydark.C900" },}}/>} label="Bi-Annual (Recommended)" />
                      <FormControlLabel value="3" control={<Radio sx={{color: "greydark.100","&.Mui-checked": { color: "greydark.C900" },}}/>} label="Quarterly" />
                    </RadioGroup>
                  </FormControl>

                  <FormControl>
                    <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 400 }}>
                      Choose longer Contract Period to save money
                    </Typography>
                    <RadioGroup
                      row
                      value={selectedPlan}
                      onChange={(e) => setSelectedPlan(e.target.value)}
                    >
                      <FormControlLabel value="1" control={<Radio sx={{color: "greydark.100","&.Mui-checked": { color: "greydark.C900" },}}/>} label="1 Year" />
                      <FormControlLabel value="2" control={<Radio sx={{color: "greydark.100","&.Mui-checked": { color: "greydark.C900" },}}/>} label="24 Months" />
                      <FormControlLabel value="3" control={<Radio sx={{color: "greydark.100","&.Mui-checked": { color: "greydark.C900" },}}/>} label="48 Months (Recommended)" />
                    </RadioGroup>
                  </FormControl>
                </Stack>

                <Divider sx={{ my: 3 }} />

                {/* === Add-On Packages === */}
                <Box>
                  <Typography variant="subtitle1" sx={{mb:1, fontWeight: 600 }}>
                    Optionally add test packages to your first lab visit (one-time):
                  </Typography>
                  <ButtonsMain
                    action={() => setShowAddOns((prev) => !prev)}
                    endIcon={showAddOns ? <ChevronUp /> : <ChevronDown />}
                    sx={{
                      textTransform: "none",
                      borderRadius: 2,
                      mb: 1,
                    }}
                  
                    name={showAddOns ? "Hide Add-On Packages" : "Show Add-On Packages"}
                  />

                  <Collapse in={showAddOns} timeout="auto" unmountOnExit>
                    <Box sx={{ mt: 1, mb: 2, pl: 2 }}>
                      {addOns.map((a) => (
                        <Stack
                          key={a.id}
                          direction="row"
                          alignItems="center"
                          spacing={1}
                          sx={{ mb: 1 }}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={selectedAddOns.includes(a.id)}
                                onChange={() => toggleAddOn(a.id)}
                              />
                            }
                            label={`${a.name} (+ € ${a.price})`}
                          />
                          <Tooltip title={`More info about ${a.name}`}>
                            <IconButton
                              size="small"
                              onClick={() => {
                                setInfoContent(a.component);
                                setInfoOpen(true);
                              }}
                            >
                              <Info size={18} />
                            </IconButton>
                          </Tooltip>
                        </Stack>
                      ))}
                    </Box>
                  </Collapse>

                  {/* 💬 Info Dialog */}
                    <CustomDialogSmall
                        open={infoOpen}
                        onClose={() => setInfoOpen(false)}
                        title=""
                        content = {
                              <Grid container>
                                  <Grid size={12} sx={{display:'flex', justifyContent:'center', alignItems:'center'}}>  
                                    {infoContent}
                                  </Grid>
                                </Grid>
                                }
                        />

                </Box>

                <Divider sx={{ my: 3 }} />

                {/* === Summary === */}
                <Typography variant="subtitle1" sx={{mb:1, fontWeight: 600 }}>
                    Your Selection / Cart:
                  </Typography>
                <List dense>
                  <ListItem disablePadding sx={{ py: 0 }}>
                    <ListItemText
                      primary=""
                      sx={{
                        "& .MuiListItemText-primary": {
                          fontSize: "16px",
                          fontWeight: 600,
                        },
                      }}
                    />
                     <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 400 }}>
                     {testsPerYear} x {membershipItem.name}&nbsp;&nbsp; &nbsp;&nbsp;€ {basePrice * testsPerYear}
                    </Typography>
                  </ListItem>

                <ListItem disablePadding sx={{ py: 0 }}>
                  <ListItemText
                      primary=""
                      sx={{
                        "& .MuiListItemText-primary": {
                          fontSize: "16px",
                          fontWeight: 400,
                        },
                      }}
                    />
                   {addOnTotal > 0 && (
                     <Typography variant="subtitle1" sx={{ fontWeight: 400 }}>
                       Selected Add-Ons for first lab visit&nbsp;&nbsp;&nbsp;&nbsp; + € <motion.span>{addOnDisplay}</motion.span>
                    </Typography>
                  )}
                  </ListItem> 
                </List>

              <Divider sx={{ my: 3 }} />

                <Box sx={{ textAlign: "right", mt: 2 }}>
                 
                  {frequencyDiscount < 0 && (
                    <Typography variant="body1" color="success.main">
                      Frequency Discount per year: € <motion.span>{freqDiscDisplay}</motion.span>
                    </Typography>
                  )}

                  {planDiscount < 0 && (
                    <Typography variant="body1" color="success.main">
                      Contract Period Discount per year: € <motion.span>{planDiscDisplay}</motion.span>
                    </Typography>
                  )}

                  <Typography variant="h4" sx={{mt:2, fontWeight: 600 }}>
                    Total incl. VAT: € <motion.span>{totalDisplay}</motion.span>
                  </Typography>

                  {(frequencyDiscount + planDiscount) < 0 && (
                    <Typography
                      variant="body1"
                      color="success.main"
                      sx={{ fontWeight: 600, my: 1 }}
                    >
                      You save € {Math.abs(frequencyDiscount + planDiscount)} per year!
                    </Typography>
                  )}

                  {/* Cart + Stripe */}
                  {loading ? (
                    <Grid container sx={{justifyContent: 'center', mt: 4}}>
                      <CircularProgress size={24} />
                    </Grid>
                  ) : (
                    <Grid container spacing={2} sx={{mt: 2, justifyContent: 'center'}}>
                      <Grid size={12} sx={{maxWidth: 600}}>

                      {/*  
                        <CartItemBlood
                          selectedOption={selectedOption}
                          onOptionChange={setSelectedOption}
                        />
                      */}
                      </Grid>

                      <Grid size={12} sx={{display: 'flex', justifyContent: 'center', mb: 4}}>
                        <form onSubmit={formik.handleSubmit}>
                          <ButtonForm name="Checkout" type="submit" disabled={loading} />
                        </form>
                      </Grid>

                      {error && (
                        <Grid size={12} sx={{maxWidth: 600, mx: 'auto'}}>
                          <Alert severity="error">{error}</Alert>
                        </Grid>
                      )}
                      
                      {message && (
                        <Grid size={12} sx={{maxWidth: 600, mx: 'auto'}}>
                          <Alert severity="info">{message}</Alert>
                        </Grid>
                      )}
                    </Grid>
                  )
                }

                </Box>
              </Paper>
            </Grid>
          </Grid>


<EmbeddedCheckout 

      user={{
          id: state.user?.id,
          email: state.user?.email,
          stripe_cust_id: state.user?.stripe_customer_id
        }}
        cart={{
          planPriceId: selectedPriceId,
          addOns: selectedAddOns.map(id => ({ sku: id, quantity: 1 })),
        }}
        onSuccess={handleSuccess}
      
    />

    </>
    }
/>

  );
}


{/*Embedded Checkout 
 * Wrapper component — displays a Pay button and opens embedded payment dialog
 * Props:
 *  - user: current user object (id, email, stripe_customer_id)
 *  - cart: { planPriceId, planOption, addOns: [{sku, quantity, price}], totals: {...} }
 *  - onSuccess(): callback to proceed with onboarding
*/}